module.exports = __webpack_public_path__ + "img/envision3.22606d27.jpg";